'use client';

import { VisualsProjection } from '@lib/sanity/types/common';
import VideoPlayer from '@ui/Visuals/Video/VideoPlayer';
import cn from '@utils/cn';

type BackgroundVideoProps = {
  data?: VisualsProjection;
  className?: string;
  hideOnMobile?: boolean | null;
};

export default function BackgroundVideo({ data, className, hideOnMobile = false }: BackgroundVideoProps) {
  const mobileVideo = data?.mobile?.video;
  const defaultVideo = data?.default?.video;

  if (!data) {
    return null;
  }

  return (
    <div
      className={cn(
        'pointer-events-none fixed inset-0 -z-10 h-screen w-screen overflow-hidden',
        { 'hidden md:block': hideOnMobile },
        className,
      )}
    >
      {defaultVideo?.video?.playbackId && (
        <VideoPlayer
          className={cn(className, {
            'hidden md:block': mobileVideo?.video?.playbackId,
          })}
          playbackId={defaultVideo?.video?.playbackId}
          filename={defaultVideo?.video?.filename}
          aspect_ratio={defaultVideo?.video?.data?.aspect_ratio}
          autoPlay={defaultVideo?.autoPlay}
          muted={defaultVideo?.muted}
          loop={defaultVideo?.loop}
          opacity={defaultVideo?.opacity}
          controls={defaultVideo?.controls}
          isEagerLoad={data.isEagerLoad}
        />
      )}

      {mobileVideo?.video?.playbackId && (
        <VideoPlayer
          className={cn(className, 'md:hidden')}
          playbackId={mobileVideo?.video?.playbackId}
          filename={mobileVideo?.video?.filename}
          aspect_ratio={mobileVideo?.video?.data?.aspect_ratio}
          autoPlay={mobileVideo?.autoPlay}
          muted={mobileVideo?.muted}
          loop={mobileVideo?.loop}
          opacity={mobileVideo?.opacity}
          isEagerLoad={data.isEagerLoad}
        />
      )}
    </div>
  );
}
